/**
 * @deprecated This icon map exists only to support the legacy UseSvg.vue component.
 * For new code, import SVG icons directly:
 *   import MyIcon from "assets/icons/my-icon.svg?vue";
 *
 * Instead of loading icons from sprite files via <use xlink:href>,
 * we import each icon as a Vue component and look it up by name at runtime.
 *
 * To add a new icon: import it and add an entry to the appropriate map.
 */

// Jiffy icons (type="jiffy", the default)
import affirm from "assets/icons/affirm.svg?vue";
import affirmBtn from "assets/icons/affirm-btn.svg?vue";
import afterpayBtn from "assets/icons/afterpay-btn.svg?vue";
import cashappBtn from "assets/icons/cashapp-btn.svg?vue";
import klarnaBtn from "assets/icons/klarna-btn.svg?vue";
import sezzleBtn from "assets/icons/sezzle-btn.svg?vue";
import venmoBtn from "assets/icons/venmo-btn.svg?vue";
import afterpay from "assets/icons/afterpay.svg?vue";
import afterpayLogo from "assets/icons/afterpay-logo.svg?vue";
import alertCircle from "assets/icons/alert-circle.svg?vue";
import applePayLogo from "assets/icons/apple-pay-logo.svg?vue";
import arrowLeft from "assets/icons/arrow-left.svg?vue";
import arrowLeftTiny from "assets/icons/arrow-left-tiny.svg?vue";
import arrowRight from "assets/icons/arrow-right.svg?vue";
import arrowRightLong from "assets/icons/arrow-right-long.svg?vue";
import arrowRightTiny from "assets/icons/arrow-right-tiny.svg?vue";
import back from "assets/icons/back.svg?vue";
import borneo from "assets/icons/borneo.svg?vue";
import bulb from "assets/icons/bulb.svg?vue";
import calendar from "assets/icons/calendar.svg?vue";
import canva from "assets/icons/canva.svg?vue";
import cartNoWheels from "assets/icons/cart-no-wheels.svg?vue";
import cashapp from "assets/icons/cashapp.svg?vue";
import check from "assets/icons/check.svg?vue";
import checkBold from "assets/icons/check-bold.svg?vue";
import checkCircle from "assets/icons/check-circle.svg?vue";
import checkCircleBold from "assets/icons/check-circle-bold.svg?vue";
import checkCirclePrimary from "assets/icons/check-circle-primary.svg?vue";
import checkCurvy from "assets/icons/check-curvy.svg?vue";
import checkVerified from "assets/icons/check-verified.svg?vue";
import checkbox from "assets/icons/checkbox.svg?vue";
import checkmarkCircled from "assets/icons/checkmark-circled.svg?vue";
import chevronDown from "assets/icons/chevron-down.svg?vue";
import cloudUpload from "assets/icons/cloud-upload.svg?vue";
import cloudUpload2 from "assets/icons/cloud-upload-2.svg?vue";
import cross from "assets/icons/cross.svg?vue";
import crossThin from "assets/icons/cross-thin.svg?vue";
import customColor from "assets/icons/custom-color.svg?vue";
import downloadLine from "assets/icons/download-line.svg?vue";
import edit from "assets/icons/edit.svg?vue";
import ellipse from "assets/icons/ellipse.svg?vue";
import etsyLogo from "assets/icons/etsy-logo.svg?vue";
import fourOclock from "assets/icons/four-oclock.svg?vue";
import freeShippingTruck from "assets/icons/free-shipping-truck.svg?vue";
import fullScreen from "assets/icons/full-screen.svg?vue";
import greenBox from "assets/icons/green-box.svg?vue";
import grid from "assets/icons/grid.svg?vue";
import guarantee3 from "assets/icons/guarantee-3.svg?vue";
import home from "assets/icons/home.svg?vue";
import idea from "assets/icons/idea.svg?vue";
import infoCircle from "assets/icons/info-circle.svg?vue";
import infoCircleBold from "assets/icons/info-circle-bold.svg?vue";
import infoCircleThin from "assets/icons/info-circle-thin.svg?vue";
import jLogo from "assets/icons/j-logo.svg?vue";
import jiffy1St from "assets/icons/jiffy-1-st.svg?vue";
// jiffy-logo-small: pre-existing broken reference, icon never existed in jiffy sprite
import jiffyShirtsInline from "assets/icons/jiffy-shirts-inline.svg?vue";
import jiffyStickersInline from "assets/icons/jiffy-stickers-inline.svg?vue";
import jiffyTransfersInline from "assets/icons/jiffy-transfers-inline.svg?vue";
import johnSmithIcon from "assets/icons/john-smith-icon.svg?vue";
import lightbulbInfo from "assets/icons/lightbulb-info.svg?vue";
import menuClose from "assets/icons/menu-close.svg?vue";
import minus from "assets/icons/minus.svg?vue";
import modalClose from "assets/icons/modal-close.svg?vue";
import modalCloseBig from "assets/icons/modal-close-big.svg?vue";
import pencilPlain from "assets/icons/pencil-plain.svg?vue";
import pencilWithDoc from "assets/icons/pencil-with-doc.svg?vue";
import plus from "assets/icons/plus.svg?vue";
import popUp from "assets/icons/pop-up.svg?vue";
import promotions from "assets/icons/promotions.svg?vue";
import questionCircle from "assets/icons/question-circle.svg?vue";
import refresh from "assets/icons/refresh.svg?vue";
import rotate from "assets/icons/rotate.svg?vue";
import rotateIcon from "assets/icons/rotate-icon.svg?vue";
import search from "assets/icons/search.svg?vue";
import sendIcon from "assets/icons/send-icon.svg?vue";
import shirtO from "assets/icons/shirt-o.svg?vue";
import spaceship from "assets/icons/spaceship.svg?vue";
import spangleWand from "assets/icons/spangle-wand.svg?vue";
import sparklesGradient from "assets/icons/sparkles-gradient.svg?vue";
import starsCorners from "assets/icons/stars-corners.svg?vue";
import strongInfo from "assets/icons/strong-info.svg?vue";
import thumbsUp from "assets/icons/thumbs-up.svg?vue";
import thumbsUpGreen from "assets/icons/thumbs-up-green.svg?vue";
import trash from "assets/icons/trash.svg?vue";
import trashPrint from "assets/icons/trash-print.svg?vue";
import uploadCloudBorder from "assets/icons/upload-cloud-border.svg?vue";
import uploadCloudBox from "assets/icons/upload-cloud-box.svg?vue";
import uploadCloudPrint from "assets/icons/upload-cloud-print.svg?vue";
import venmo from "assets/icons/venmo.svg?vue";
import warning from "assets/icons/warning.svg?vue";
import warningHexagon from "assets/icons/warning-hexagon.svg?vue";
import zapFast from "assets/icons/zap-fast.svg?vue";
import zoomInO from "assets/icons/zoom-in-o.svg?vue";
import zoomInPrint from "assets/icons/zoom-in-print.svg?vue";
import zoomOutO from "assets/icons/zoom-out-o.svg?vue";
import award from "assets/icons/award.svg?vue";
import basket from "assets/icons/basket.svg?vue";
import boxJiffyCheck from "assets/icons/box-jiffy-check.svg?vue";
import boxJiffyPacked from "assets/icons/box-jiffy-packed.svg?vue";
import crossCircle from "assets/icons/cross-circle.svg?vue";
import dollarShield from "assets/icons/dollar-shield.svg?vue";
import dollarSign from "assets/icons/dollar-sign.svg?vue";
import fastDelivery from "assets/icons/fast-delivery.svg?vue";
import guarantee from "assets/icons/guarantee.svg?vue";
import heart from "assets/icons/heart.svg?vue";
import heartFilled from "assets/icons/heart-filled.svg?vue";
import hellip from "assets/icons/hellip.svg?vue";
import imageCheck from "assets/icons/image-check.svg?vue";
import jiffyStickersLogo from "assets/icons/jiffy-stickers-logo.svg?vue";
import lightning1 from "assets/icons/lightning-1.svg?vue";
import loader from "assets/icons/loader.svg?vue";
import lock from "assets/icons/lock.svg?vue";
import lockOutline from "assets/icons/lock-outline.svg?vue";
import markerPin from "assets/icons/marker-pin.svg?vue";
import pencil from "assets/icons/pencil.svg?vue";
import plusCircle from "assets/icons/plus-circle.svg?vue";
import proColorWheel from "assets/icons/pro-color-wheel.svg?vue";
import sezzleLogo from "assets/icons/sezzle-logo.svg?vue";
import shipping from "assets/icons/shipping.svg?vue";
import stickyNote from "assets/icons/sticky-note.svg?vue";
import thumbsDown from "assets/icons/thumbs-down.svg?vue";

// Neck labels icons (type="neck_labels") — stored with care- prefix
import careChlorineBleach from "assets/icons/neck-label-chlorine-bleach.svg?vue";
import careDoNotBleach from "assets/icons/neck-label-do-not-bleach.svg?vue";
import careDoNotIron from "assets/icons/neck-label-do-not-iron.svg?vue";
import careDoNotWash from "assets/icons/neck-label-do-not-wash.svg?vue";

const jiffyIcons = {
  "affirm": affirm,
  "affirm-btn": affirmBtn,
  "afterpay-btn": afterpayBtn,
  "cashapp-btn": cashappBtn,
  "klarna-btn": klarnaBtn,
  "sezzle-btn": sezzleBtn,
  "venmo-btn": venmoBtn,
  "afterpay": afterpay,
  "afterpay-logo": afterpayLogo,
  "alert-circle": alertCircle,
  "apple-pay-logo": applePayLogo,
  "arrow-left": arrowLeft,
  "arrow-left-tiny": arrowLeftTiny,
  "arrow-right": arrowRight,
  "arrow-right-long": arrowRightLong,
  "arrow-right-tiny": arrowRightTiny,
  "back": back,
  "borneo": borneo,
  "bulb": bulb,
  "calendar": calendar,
  "canva": canva,
  "cart-no-wheels": cartNoWheels,
  "cashapp": cashapp,
  "check": check,
  "check-bold": checkBold,
  "check-circle": checkCircle,
  "check-circle-bold": checkCircleBold,
  "check-circle-primary": checkCirclePrimary,
  "check-curvy": checkCurvy,
  "check-verified": checkVerified,
  "checkbox": checkbox,
  "checkmark-circled": checkmarkCircled,
  "chevron-down": chevronDown,
  "cloud-upload": cloudUpload,
  "cloud-upload-2": cloudUpload2,
  "cross": cross,
  "cross-thin": crossThin,
  "custom-color": customColor,
  "download-line": downloadLine,
  "edit": edit,
  "ellipse": ellipse,
  "etsy-logo": etsyLogo,
  "four-oclock": fourOclock,
  "free-shipping-truck": freeShippingTruck,
  "full-screen": fullScreen,
  "green-box": greenBox,
  "grid": grid,
  "guarantee-3": guarantee3,
  "home": home,
  "idea": idea,
  "info-circle": infoCircle,
  "info-circle-bold": infoCircleBold,
  "info-circle-thin": infoCircleThin,
  "j-logo": jLogo,
  "jiffy-1-st": jiffy1St,
  "jiffy-shirts-inline": jiffyShirtsInline,
  "jiffy-stickers-inline": jiffyStickersInline,
  "jiffy-transfers-inline": jiffyTransfersInline,
  "john-smith-icon": johnSmithIcon,
  "lightbulb-info": lightbulbInfo,
  "menu-close": menuClose,
  "minus": minus,
  "modal-close": modalClose,
  "modal-close-big": modalCloseBig,
  "pencil-plain": pencilPlain,
  "pencil-with-doc": pencilWithDoc,
  "plus": plus,
  "pop-up": popUp,
  "promotions": promotions,
  "question-circle": questionCircle,
  "refresh": refresh,
  "rotate": rotate,
  "rotate-icon": rotateIcon,
  "search": search,
  "send-icon": sendIcon,
  "shirt-o": shirtO,
  "spaceship": spaceship,
  "spangle-wand": spangleWand,
  "sparkles-gradient": sparklesGradient,
  "stars-corners": starsCorners,
  "strong-info": strongInfo,
  "thumbs-up": thumbsUp,
  "thumbs-up-green": thumbsUpGreen,
  "trash": trash,
  "trash-print": trashPrint,
  "upload-cloud-border": uploadCloudBorder,
  "upload-cloud-box": uploadCloudBox,
  "upload-cloud-print": uploadCloudPrint,
  "venmo": venmo,
  "warning": warning,
  "warning-hexagon": warningHexagon,
  "zap-fast": zapFast,
  "zoom-in-o": zoomInO,
  "zoom-in-print": zoomInPrint,
  "zoom-out-o": zoomOutO,
  "award": award,
  "basket": basket,
  "box-jiffy-check": boxJiffyCheck,
  "box-jiffy-packed": boxJiffyPacked,
  "cross-circle": crossCircle,
  "dollar-shield": dollarShield,
  "dollar-sign": dollarSign,
  "fast-delivery": fastDelivery,
  "guarantee": guarantee,
  "heart": heart,
  "heart-filled": heartFilled,
  "hellip": hellip,
  "image-check": imageCheck,
  "jiffy-stickers-logo": jiffyStickersLogo,
  "lightning-1": lightning1,
  "loader": loader,
  "lock": lock,
  "lock-outline": lockOutline,
  "marker-pin": markerPin,
  "pencil": pencil,
  "plus-circle": plusCircle,
  "pro-color-wheel": proColorWheel,
  "sezzle-logo": sezzleLogo,
  "shipping": shipping,
  "sticky-note": stickyNote,
  "thumbs-down": thumbsDown,
};

const neckLabelsIcons = {
  "chlorine-bleach": careChlorineBleach,
  "do-not-bleach": careDoNotBleach,
  "do-not-iron": careDoNotIron,
  "do-not-wash": careDoNotWash,
};

// product_collections and brand_page types use the same icons as jiffy
const iconMaps = {
  jiffy: jiffyIcons,
  brand_page: jiffyIcons,
  product_collections: jiffyIcons,
  neck_labels: neckLabelsIcons,
};

export function getIconComponent(name, type = "jiffy") {
  const map = iconMaps[type] || jiffyIcons;
  return map[name] || null;
}
